import React from 'react';
import { useTranslation } from 'react-i18next';
import IndividualRankingDetailsTable from './IndividualRankingDetailsTable';
import GroupRankingDetailsTable from './GroupRankingDetailsTable';
import RankingDetails from './RankingDetails';
import { GroupScType } from '../../../models/SpecialConsideration';

interface RankingDetailsTableProps {
  groupScType: GroupScType;
  examLevel: string;
  modeOfAssessment: string;
}

const RankingDetailsTable = ({
  groupScType,
  examLevel,
  modeOfAssessment,
}: RankingDetailsTableProps) => {
  const { t } = useTranslation();

  return (
    <RankingDetails
      sectionHeader={t('specialConsideration->>ApplyForSpecialConsideration.RankingDetails')}
      rankingTable={
        groupScType === GroupScType.IND ? (
          <IndividualRankingDetailsTable
            isPsle={examLevel === 'PSLE'}
            modeOfAssessment={modeOfAssessment}
          />
        ) : (
          <GroupRankingDetailsTable />
        )
      }
    />
  );
};

export default RankingDetailsTable;
